import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import RouteOutlinedIcon from "@mui/icons-material/RouteOutlined";
import { useFirebase } from "../context/ApiContext";
import { DashboardLayout } from "../components/Dashboard";
import SeoHead from "../components/Seo/SeoHead";
import "./RutasPage.css";

const CREATE_ROUTE_CATALOG = [
	{
		id: "nueva-york",
		city: "Nueva York",
		label: "Gratis",
		description: "Diseña tu día con stickers y descárgalo para Stories",
		available: true,
		path: "/crear-ruta",
	},
	{
		id: "mas-ciudades",
		city: "Más ciudades",
		label: "Pronto",
		description: "Más destinos próximamente",
		available: false,
	},
];

const RUTAS_CATALOG = [
	{
		id: "tokio-4",
		slug: "tokio",
		city: "Tokio",
		days: 4,
		label: "4 días",
		description: "La ruta perfecta para descubrir lo mejor de Tokio en 4 días",
		available: true,
	},
];

const RutasIndexPage = () => {
	const navigate = useNavigate();
	const { user, handleLogout: contextLogout } = useFirebase();

	const formattedUser = user
		? { displayName: user.displayName, email: user.email }
		: null;

	const handleSectionChange = (sectionId) => {
		if (sectionId === "home") navigate("/");
		else if (sectionId === "explore") navigate("/explorar");
		else if (sectionId === "passport") navigate("/passport");
		else if (sectionId === "rutas") navigate("/rutas");
		else if (sectionId === "my-guides") navigate("/mis-guias");
		else if (sectionId === "favorites") navigate("/favoritos");
		else if (sectionId === "modules") navigate("/modulos");
		else if (sectionId === "discounts") navigate("/descuentos");
		else if (sectionId === "travel-card") navigate("/tarjeta-viajera");
		else if (sectionId === "create") navigate("/crear-guia");
		else navigate("/");
	};

	const handleLogout = async () => {
		try {
			await contextLogout();
			navigate("/");
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<>
			<SeoHead
				title="Rutas interactivas — Viajes Molones"
				description="Descubre rutas día a día para tus viajes. Itinerarios interactivos con mapa, progreso y recuerdos."
				path="/rutas"
			/>
			<DashboardLayout
				user={formattedUser}
				activeSection="rutas"
				onSectionChange={handleSectionChange}
				onLogin={() => navigate("/")}
				onSignUp={() => navigate("/")}
				onLogout={handleLogout}
				onCreateNew={() => navigate("/crear-guia")}
				onSearch={() => {}}
				prebuiltGuides={[]}
				myGuides={[]}
				imageMap={{}}
			>
				<Box sx={{ mt: { xs: 1, md: 0 } }}>
					<div className="rutas-page">
						<div className="rutas-index-header">
							<h1 className="rutas-index-title">Rutas</h1>
							<p className="rutas-index-subtitle">
								Elige una ruta interactiva o crea la tuya para Stories
							</p>
						</div>

						<section className="rutas-index-section">
							<h2 className="rutas-index-section-title">Crea tu ruta</h2>
							<div className="rutas-index-grid">
								{CREATE_ROUTE_CATALOG.map((ruta) => (
									<div
										key={ruta.id}
										className={`rutas-index-card rutas-index-card--create ${!ruta.available ? "coming-soon" : ""}`}
										onClick={() =>
											ruta.available && ruta.path && navigate(ruta.path)
										}
										role={ruta.available ? "button" : undefined}
										tabIndex={ruta.available ? 0 : undefined}
										onKeyDown={(e) => {
											if (
												ruta.available &&
												ruta.path &&
												(e.key === "Enter" || e.key === " ")
											) {
												e.preventDefault();
												navigate(ruta.path);
											}
										}}
									>
										{!ruta.available && (
											<span className="rutas-index-badge-soon">Próximamente</span>
										)}
										<div className="rutas-index-card-emoji rutas-index-card-emoji--create">
											<MapOutlinedIcon sx={{ fontSize: 28, color: "#6366f1" }} />
										</div>
										<div className="rutas-index-card-info">
											<h3 className="rutas-index-card-city">{ruta.city}</h3>
											<span className="rutas-index-card-days rutas-index-card-days--create">
												{ruta.label}
											</span>
											<p className="rutas-index-card-desc">{ruta.description}</p>
										</div>
										{ruta.available && (
											<span className="rutas-index-card-arrow rutas-index-card-arrow--create">
												→
											</span>
										)}
									</div>
								))}
							</div>
						</section>

						<section className="rutas-index-section">
							<h2 className="rutas-index-section-title">Rutas interactivas</h2>
							<div className="rutas-index-grid">
								{RUTAS_CATALOG.map((ruta) => (
									<div
										key={ruta.id}
										className={`rutas-index-card ${!ruta.available ? "coming-soon" : ""}`}
										onClick={() =>
											ruta.available &&
											navigate(`/rutas/${ruta.slug}`, {
												state: { from: "/rutas" },
											})
										}
									>
										{!ruta.available && (
											<span className="rutas-index-badge-soon">Próximamente</span>
										)}
										<div className="rutas-index-card-emoji">
											<RouteOutlinedIcon sx={{ fontSize: 28, color: "#e8677d" }} />
										</div>
										<div className="rutas-index-card-info">
											<h3 className="rutas-index-card-city">{ruta.city}</h3>
											<span className="rutas-index-card-days">{ruta.label}</span>
											<p className="rutas-index-card-desc">{ruta.description}</p>
										</div>
										{ruta.available && (
											<span className="rutas-index-card-arrow">→</span>
										)}
									</div>
								))}
							</div>
						</section>
					</div>
				</Box>
			</DashboardLayout>
		</>
	);
};

export default RutasIndexPage;
